<template>
    <div class="quickPay">
        <img class="quickPay-header-image" src="@/assets/images/pay/pay-quick.png" alt="" />
        <div class="quickPay-wrap">
            <div class="quickPay-type flex justify-between">
                <div class="quickPay-type-item" v-for="(item, index) in carTypeList" :key="index" @click="changeType(item)">
                    <p v-if="index < 2" :class="[type == item.type ? 'quickPay-type-item-textA' : 'quickPay-type-item-text', 'flex', 'align-center', 'justify-center']">{{ item.name }} <img v-if="item.type == 3" src="@/assets/images/pay/down.png" alt="" /></p>
                    <p v-if="index == 2" :class="[type >= item.type ? 'quickPay-type-item-textA' : 'quickPay-type-item-text', 'flex', 'align-center', 'justify-center']">{{ item.name }} <img v-if="item.type == 3" src="@/assets/images/pay/down.png" alt="" /></p>
                </div>
            </div>
        </div>
        <div class="quickPay-content">
            <CarKeyboard ref="CarKeyboard" :addType="false" :carNoList.sync="carNoList" :cartype.sync="type" @confirmBtnFn="getResult" :showDefault="false" />
            <div v-if="historyCar.length > 0" class="quickPay-code-list">
                <p class="quickPay-code-history">车牌信息</p>
                <div class="quickPay-code-wrap flex align-center nowrap">
                    <!-- <div
                        :class="[
                            'quickPay-code-item',
                            item.plateColor == 1 
                                ? 'quickPay-code-item-blue'
                                : item.plateColor == 2
                                ? 'quickPay-code-item-green'
                                : item.plateColor == 3
                                ? 'quickPay-code-item-yellow'
                                : item.plateColor == 4
                                ? 'quickPay-code-item-temp'
                                : item.plateColor == 5
                                ? 'quickPay-code-item-black'
                                : item.plateColor == 6
                                ? 'quickPay-code-item-white'
                                : item.plateColor == 7
                                ? 'quickPay-code-item-yellow-green'
                                : 'quickPay-code-item-blue',
                        ]"
                        v-for="(item, index) in carList"
                        @click="pickCar(item)"
                        :key="index"
                    > -->
                    <div :class="['quickPay-code-item', item.plateNum.length == 7 ? 'quickPay-code-item-blue' : 'quickPay-code-item-green']" v-for="(item, index) in historyCar" @click="pickCar(item)" :key="index">
                        <p class="code-item-number">{{ item.plateNum }}</p>
                        <div v-if="plateNum == item.plateNum" class="quickPay-code-itemA">
                            <!-- <div v-if="plateNum == item.plateNum && type == item.plateColor" class="quickPay-code-itemA"> -->
                            <img src="@/assets/images/pay/car-bg-checked.png" alt="" />
                        </div>
                        <div class="car-delete" @click.stop="deleteHistory(index, item)">
                            <div class="line"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="quickPay-tip flex align-center">
                <img src="@/assets/images/pay/pay-tip.png" alt="" />
                <p>付款成功请尽快离场，超时将加收停车费</p>
            </div>
            <van-button class="comfirm-btn" v-debounce="searchFee">查询费用</van-button>
        </div>
        <!-- 其他车牌弹出 -->
        <van-action-sheet v-model="showCodeType" description="请选择车牌颜色">
            <div class="content-other">
                <div :class="[activeCode == item.id ? 'content-other-itemA' : 'content-other-item']" @click="clickOtherItem(item)" v-for="(item, index) in otherCarType" :key="index">
                    <p>{{ item.color }}</p>
                </div>
                <div class="content-other-btn flex align-center justify-between">
                    <van-button @click="canclePick" plain color="#009AF3" block class="content-btn">取消</van-button>
                    <van-button @click="confirmPick" color="#009AF3" block class="content-btn">确定</van-button>
                </div>
            </div>
        </van-action-sheet>

        <!-- 欠费列表 -->
        <div class="record-list" v-if="ArrearList.length > 0">
            <div class="record-list-item" v-for="item in ArrearList" :key="item.parkingRecordId">
                <div class="record-item-header flex align-center justify-between">
                    <p class="record-item-site">
                        <span style="color: #009af3" v-if="item.type == 2">路外</span>
                        <span style="color: #009af3" v-if="item.type == 1">路内</span>
                        {{ item.plateNum }}
                    </p>
                </div>
                <div class="parkingPay-carInfo-content">
                    <div class="carInfo-content-item flex align-center">
                        <img class="carInfo-content-item1" src="@/assets/images/pay/parkingPay-number.png" alt="" />
                        <p class="carInfo-content-item-title">停车场</p>
                        <p class="carInfo-content-item-value">{{ item.parkName }}</p>
                    </div>

                    <div class="carInfo-content-item flex align-center">
                        <img class="carInfo-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                        <p class="carInfo-content-item-title">停车时长</p>
                        <p class="carInfo-content-item-value" style="color: #009af3">{{ secondToMinute(item.parkSeconds) }}分钟</p>
                    </div>
                    <div class="carInfo-content-item flex align-center">
                        <img class="carInfo-content-item1" src="@/assets/images/pay/parkingPay-code.png" alt="" />
                        <p class="carInfo-content-item-title">还需缴费</p>
                        <p class="carInfo-content-item-value money">￥{{ item.needPay }}</p>
                    </div>
                </div>
                <div class="record-item-pay">
                    <van-button v-if="Number(item.needPay) > 0" class="record-item-pay-btn" @click="payNow(item)">立即缴费</van-button>

                    <!-- <van-button v-if="isArrearsFlag" class="record-item-pay-btn" plain color="#009AF3 " @click="skipBill">代缴费用查询</van-button> -->
                </div>
            </div>
        </div>

        <telephonne />
    </div>
</template>

<script>
import CarKeyboard from "@/components/car-keyboard.vue";
import { queryParkingRecordByCarNo } from "@/api/apiNoAuth";
import { isUnionApp } from "@/libs/tools";
import { secondToMinute } from "@/libs/tools";
import Telephonne from "@/components/telephone";
import DialogBox from "@/components/base/dialog/iconDialog.js";
import { payEnv } from "@/libs/tools";
export default {
    name: "QuickPay",
    components: {
        CarKeyboard,
        Telephonne,
    },

    data() {
        return {
            type: 1,
            active: 0,
            carNoList: ["闽", "C"], //单个车牌号数组
            oldType: "", //老的type
            carTypeList: [
                {
                    name: "蓝牌",
                    type: 1,
                },
                {
                    name: "绿牌",
                    type: 2,
                },
                // {
                //     name: "其他",
                //     type: 3,
                // },
            ],
            carList: [],
            otherCarType: [
                {
                    color: "黄牌",
                    id: 1,
                },
                {
                    color: "临牌",
                    id: 2,
                },
                {
                    color: "黑牌",
                    id: 3,
                },
                {
                    color: "白牌",
                    id: 4,
                },
                {
                    color: "黄绿",
                    id: 5,
                },
            ],
            activeCode: 1,
            showCodeType: false,
            tmpOtherData: {
                color: "黄牌",
                id: 1,
            },
            plateNum: "", //车牌号
            ArrearList: [], //欠费列表
            historyCar: [], //搜索历史车牌
            isArrearsFlag: false,
            noChangeCarList: [], //未使用的CarList
        };
    },

    mounted() {
        if (!payEnv()) {
            DialogBox({
                type: "fail",
                content: `请使用云闪付APP、微信、支付宝扫码`,
                rightBtnClick() {},
            });

            return;
        }

        this.getSearchHistory();
    },
    methods: {
        secondToMinute,

        //获取车牌
        getCarList() {
            listMyPlateNum().then((res) => {
                this.carList = res.data;
                this.noChangeCarList = [...res.data];
                let length = 4 - res.data.length;
                for (let i = 0; i < length; i++) {
                    if (this.historyCar[i]) {
                        this.historyCar[i].carNo = this.historyCar[i].plateNum;
                        this.historyCar[i].isHistory = true;
                        this.carList.push(this.historyCar[i]);
                    }
                }
            });
        },

        // 删除历史查询车牌
        deleteHistory(index, item) {
            // this.carList.splice(index, 1);
            this.carList = JSON.parse(JSON.stringify(this.noChangeCarList));
            this.historyCar = this.historyCar.filter((i) => {
                return i.plateNum != item.plateNum;
            });

            let length = 4 - this.noChangeCarList.length;

            for (let i = 0; i < length; i++) {
                if (this.historyCar[i]) {
                    this.historyCar[i].carNo = this.historyCar[i].plateNum;
                    this.historyCar[i].isHistory = true;
                    this.carList.push(this.historyCar[i]);
                }
            }
            localStorage.setItem("historyCar", JSON.stringify(this.historyCar));
        },
        // 车牌颜色改变事件
        changeType(item) {
            //有键盘时不能修改类型
            if (this.$refs.CarKeyboard.show_keyboard) return;
            this.oldType = this.type;
            this.type = item.type;

            if (this.type == 3) {
                this.showCodeType = true;
            }
        },

        // 车牌输入获取结果
        // 车牌输入获取结果
        getResult(data, isDefault, isSearch) {
            this.plateNum = data;
            if (isSearch) {
                this.searchFee();
            }
        },
        // 选择已有车牌号
        pickCar(item) {
            this.plateNum = item.plateNum;
            this.active = item.id;

            //根据车牌长度确定颜色
            this.type = item.plateNum.length == 7 ? 1 : 2;

            // 选择车牌更改tab的显示
            if (item.plateColor >= 3) {
                this.carTypeList[2].name = this.colorToStr(item.plateColor);
                this.activeCode = item.plateColor - 2;
            }
            //先等type赋值
            this.$nextTick(() => {
                this.carNoList = item.plateNum.split("");
            });
        },
        // 其他车牌弹出点击
        clickOtherItem(item) {
            this.activeCode = item.id;
            this.tmpOtherData = item;
        },
        // 提交选择其他车牌
        confirmPick() {
            this.showCodeType = false;
            this.carTypeList[2].name = this.tmpOtherData.color;
            this.type = this.activeCode + 2;
        },
        // 取消选择车牌
        canclePick() {
            this.showCodeType = false;
            this.carTypeList[2].name = "其他";
            this.type = this.oldType;
        },

        //查询费用
        searchFee() {
            //屏幕大的在点击查询费用后需要隐藏键盘
            if (this.$refs.CarKeyboard.show_keyboard) {
                this.plateNum = this.$refs.CarKeyboard.sonCarNoList.join("");
                this.$refs.CarKeyboard.show_keyboard = false;
            }

            if (!this.isRightCar(this.plateNum, this.type)) {
                this.$toast("请输入正确车牌");
                return;
            }
            //判断是否查询绑定的车牌，未绑定则存
            let flag = this.noChangeCarList.some((item) => item.plateNum == this.plateNum);
            let obj = { plateNum: this.plateNum };
            if (flag) {
                obj.plateColor = this.type;
            }
            //只存未绑定的车牌
            else {
                this.setSearchHistory({ ...obj });
            }
            //重新计算车牌
            // this.getCarList();

            //设置车牌
            queryParkingRecordByCarNo(obj).then((res) => {
                if (res.data.length == 0) {
                    this.ArrearList = [];
                    this.$toast("暂无停车记录");
                    return;
                } else {
                    this.ArrearList = res.data;
                }
            });
        },
        //拿取本地的搜素历史
        getSearchHistory() {
            this.historyCar = JSON.parse(localStorage.getItem("historyCar")) || [];
        },
        //正确车位判断
        isRightCar(placeNum, type) {
            //蓝牌 黄牌 临牌 黑牌  白牌 只能七位
            if (type == 1 || type == 3 || type == 4 || type == 5 || type == 6) {
                if (placeNum.length < 7) {
                    return false;
                }
                return true;
            }

            // 绿牌 黄绿牌 八位
            else if (this.type == 2 || this.type == 7) {
                if (placeNum.length < 8) {
                    return false;
                }
                return true;
            }
        },
        //设置搜索历史车牌
        setSearchHistory(obj) {
            //如果传入的obj没有颜色默认给定当前type
            if (!obj.plateColor) {
                obj.plateColor = this.type;
            }
            if (localStorage.getItem("historyCar")) {
                //如果historyCar存在
                let historyList = JSON.parse(localStorage.getItem("historyCar"));
                let index = historyList.findIndex((item) => obj.plateNum == item.plateNum);
                //搜索项存在,将存在的拿到头部
                if (index != -1) {
                    historyList.splice(index, 1);
                    historyList.unshift(obj);
                    this.historyCar = historyList.slice(0, 4);
                    //最多存入四个
                    localStorage.setItem("historyCar", JSON.stringify(this.historyCar));
                }
                //搜索项不存在
                else {
                    historyList.unshift(obj);
                    this.historyCar = historyList.slice(0, 4);
                    localStorage.setItem("historyCar", JSON.stringify(this.historyCar));
                }
            }
            //如果historyCar不存在
            else {
                let historyList = [obj];
                this.historyCar = historyList;
                localStorage.setItem("historyCar", JSON.stringify(this.historyCar));
            }
        },
        //缴费
        payNow(item) {
            let obj = {
                parkingRecordId: item.parkingRecordId,
                parkType: item.type,
                needPay: item.needPay,
                payStatus: 1,
            };
            this.$router.push({ name: "ParkingunionPay", query: obj });
        },
        //跳转到未支付页面
        skipBill() {
            this.$router.push({ name: "Bill" });
        },
        // 输出车牌num 转成str
        colorToStr(color) {
            let str = "";
            switch (color) {
                case 1:
                    str = "蓝牌";
                    break;
                case 2:
                    str = "绿牌";
                    break;
                case 3:
                    str = "黄牌";
                    break;
                case 4:
                    str = "临牌";
                    break;
                case 5:
                    str = "黑牌";
                    break;
                case 6:
                    str = "白牌";
                    break;
                case 7:
                    str = "黄绿";
                    break;
                default:
                    str = "";
                    break;
            }
            return str;
        },
    },
};
</script>

<style lang="less" scoped>
.quickPay {
    .quickPay-header-image {
        width: 750px;
        height: 200px;
    }
    .quickPay-wrap {
        background: #fff;
        padding: 15px 0;
        .quickPay-type {
            width: 702px;
            height: 64px;
            border: 1px solid #dbdada;
            border-radius: 16px;
            margin: 0 auto;

            .quickPay-type-item {
                height: 100%;
                flex: 1;

                .quickPay-type-item-text {
                    font-size: 28px;
                    color: #666666;
                    text-align: center;
                    line-height: 64px;
                    position: relative;

                    &::before {
                        content: "";
                        width: 1px;
                        height: 40px;
                        position: absolute;
                        background-color: #dbdada;
                        top: 12px;
                        left: 0;
                    }
                }

                &:nth-child(1) {
                    .quickPay-type-item-text {
                        position: relative;

                        &::before {
                            content: "";
                            width: 0;
                        }
                    }
                }

                .quickPay-type-item-textA {
                    font-size: 28px;
                    height: 100%;
                    line-height: 64px;
                    color: #fff;
                    text-align: center;
                    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
                    border-radius: 15px;
                }

                img {
                    width: 12px;
                    height: 8px;
                    margin-left: 10px;
                }
            }
        }
    }
    .quickPay-content {
        padding: 24px;
        background-color: #fff;
        .quickPay-code-list {
            width: 702px;
            min-height: 204px;
            background: #009af31a;
            border-radius: 16px;
            padding: 24px;
            .quickPay-code-history {
                font-size: 30px;
                color: #212121;
                margin-bottom: 23px;
            }
            .quickPay-code-wrap {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;
                // overflow-x: scroll;
                &:after {
                    content: "";
                    width: 302px; //这个宽度和子元素宽度一致
                    height: 0;
                    display: block;
                }
                .quickPay-code-item-green {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;
                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-green.png") no-repeat;
                    color: #110b0d;
                }
                .quickPay-code-item-blue {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-blue.png") no-repeat;
                    color: #fff;
                }
                .quickPay-code-item-yellow {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-yellow.png") no-repeat;
                    color: #110b0d;
                }
                .quickPay-code-item-temp {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-temp.png") no-repeat;
                    color: #110b0d;
                }
                .quickPay-code-item-black {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-black.png") no-repeat;
                    color: #fff;
                }
                .quickPay-code-item-white {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-white.png") no-repeat;
                    color: #110b0d;
                }
                .quickPay-code-item-yellow-green {
                    width: 302px;
                    font-size: 46px;
                    margin: 10px 0;

                    flex-shrink: 0;
                    background: url("~@/assets/images/pay/car-bg-yellow-green.png") no-repeat;
                    color: #110b0d;
                }
                .quickPay-code-item {
                    height: 88px;
                    position: relative;
                    flex-shrink: 0;
                    background-size: 100% 100%;
                    margin-right: 16px;
                    .code-item-number {
                        white-space: nowrap;

                        line-height: 88px;
                        text-align: center;
                    }
                    .quickPay-code-itemA {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        left: 0;
                        top: 0;
                        background: #009af3cc;
                        border-radius: 8px;
                        img {
                            position: absolute;
                            width: 48px;
                            height: 48px;
                            left: 0;
                            right: 0;
                            top: 0;
                            bottom: 0;
                            margin: auto;
                        }
                    }
                }
            }
        }
        .quickPay-tip {
            margin-top: 70px;
            img {
                width: 24px;
                height: 24px;
            }
            p {
                font-size: 26px;
                color: #616161;
                margin-left: 8px;
            }
        }
    }
    .content-other {
        .content-other-itemA {
            width: 702px;
            height: 64px;
            background: #009af333;
            border-radius: 16px;
            margin: 0 22px;
            p {
                color: #009af3;
                line-height: 64px;
                text-align: center;
            }
        }
        .content-other-item {
            width: 702px;
            height: 64px;
            // background: #009AF333;
            border-radius: 16px;
            margin: 0 22px;
            p {
                color: #666666;
                line-height: 64px;
                text-align: center;
            }
        }
        .content-other-btn {
            width: 750px;
            padding: 22px;
            .content-btn {
                width: 343px;
                height: 70px;
                border-radius: 16px;
            }
        }
    }
}

.car-delete {
    height: 30px;
    width: 30px;
    position: absolute;
    top: -10px;
    right: -10px;
    color: #000;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: red;
    .line {
        height: 5px;
        width: 20px;
        background-color: #fff;
        border-radius: 10px;
    }
    // background: url("~@/assets/images/pay/close.png") no-repeat;
    // background-size: 100% 100%;
}

.record-list {
    padding: 16px 24px;
    .record-list-item {
        width: 702px;
        border-radius: 16px;
        background-color: #fff;
        margin-bottom: 16px;
        .record-item-header {
            width: 100%;
            height: 73px;
            padding: 0 30px;
            border-bottom: 1px solid #dbdada;
            .record-item-site {
                font-size: 30px;
                color: #333333;
            }
            .record-item-status {
                font-size: 30px;
            }
            .color-gray {
                color: #999;
            }
            .color-red {
                color: #f96161;
            }
        }
        .parkingPay-carInfo-content {
            flex: 1;
            padding: 24px 44px 27px;

            .carInfo-content-header {
                font-size: 32px;
                font-weight: 500;
                color: #212121;
                margin-bottom: 30px;
            }

            .carInfo-content-item {
                margin-bottom: 16px;

                .carInfo-content-item1 {
                    width: 24px;
                    height: 24px;
                }

                .carInfo-content-item2 {
                    width: 24px;
                    height: 28px;
                }

                .carInfo-content-item-title {
                    margin-left: 17px;
                    vertical-align: top;
                }

                .carInfo-content-item-value {
                    margin-left: auto;
                    color: #666666;
                }
                .money {
                    font-size: 30px;
                    color: #009af3;
                }
            }
        }
        .record-item-pay {
            padding: 0 30px 30px;
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;
            .record-item-pay-btn {
                width: 310px;
                height: 60px;
                white-space: nowrap;
                color: #fff;
                border-radius: 10px;
                background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
            }
        }
    }
}
.comfirm-btn {
    color: #fff;
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
}
</style>
